import { useState } from "react";
import { getChat } from "../../api/requests/chat";
import { useTranslation } from "react-i18next";
import { IonButton, useIonRouter } from "@ionic/react";
import { useDispatch } from "react-redux";
import { chatSlicer } from "../../redux/slicers/chatSlicer";

export const MessageBtn = ({ userId, query = "" }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const router = useIonRouter();
  const dispatch = useDispatch();

  const handleClick = async () => {
    setLoading(true);
    const result = await getChat(userId);
    setLoading(false);
    if (result && result.data) {
      dispatch(chatSlicer.actions.addChat(result.data));
      router.push("/messages/" + result.data._id + query);
    }
  };

  return (
    <IonButton
      fill="solid"
      size="medium"
      color="danger"
      onClick={handleClick}
      disabled={loading}
      className="message-button ion-no-margin"
    >
      {loading ? t("loading") : t("message")}
    </IonButton>
  );
};
